import Stack from '@mui/material/Stack';
import CheckMarkIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import TonalityIcon from '@mui/icons-material/Tonality';

const getIcon = status => {
  switch(status) {
    case 'COMPLETED':
      return <CheckMarkIcon color='success'/>;
    case 'ERROR':
      return <ErrorIcon color='error' />;
    case 'GENERATING':
      return <TonalityIcon color='warning' />;
    default:
      return () => null;
  }
};

const ReportStatus = ({report}) => {
  const Icon = getIcon(report.status);
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      {Icon}
      <span>{report.status}</span>
    </Stack>
  );
};

export default ReportStatus;